import React, { useState, useEffect } from "react";
import "./AddressSelectionModal.css";
import { useForm } from "react-hook-form";
import { getUserCurrentLocation } from "../api/AuthApi.services"
import CountryStateCitySelector from "./CountryStateCitySelector";
import {Country, State, City } from "country-state-city";
import {fetchWithAuth} from "../api/AuthApi.services"

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

const AddressSelectionModal = ({ addresses, onSelect, onClose }) => {
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [isAddingNew, setIsAddingNew] = useState(false);
  // const [newAddress, setNewAddress] = useState({
  //   name: "",
  //   phone: "",
  //   address_line_1: "",
  //   city: "",
  //   state: "",
  //   country: "",
  //   postal_code: "",
  // });
  const [address, setAddress] = useState({
    country: "",
    state: "",
    city: "",
  });
  const { register: registerRegister, handleSubmit: handleRegisterSubmit, setValue, reset: resetRegisterForm } = useForm();

  const [errors, setErrors] = useState({});

  const handleLocationChange = (newAddress) => {
    setAddress(newAddress); // Update address state
    setValue("country", newAddress.country);
    setValue("state", newAddress.state);
    setValue("city", newAddress.city);
  };

  const getCurrentLocation = async () => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser.");
      return;
    }
  
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude, longitude } = pos.coords;
        try {
          const response = await getUserCurrentLocation({ latitude, longitude });
  
          if (response?.address) {
            console.log("📌 Raw Address Response:", response.address);
  
            const { country_code, state, city, postcode } = response.address;
  
            // ✅ Fetch full country name using country code
            const countryData = Country.getAllCountries().find(
              (c) => c.isoCode.toLowerCase() === country_code.toLowerCase()
            );
  
            const fullCountryName = countryData ? countryData.name : "";
  
            // ✅ Fetch state details using country code
            const countryStates = State.getStatesOfCountry(country_code.toUpperCase());
            const matchedState = countryStates.find(
              (s) => s.name.toLowerCase() === state.toLowerCase() || s.isoCode.toLowerCase() === state.toLowerCase()
            );
  
            const fullStateName = matchedState ? matchedState.name : "";
            const stateIsoCode = matchedState ? matchedState.isoCode : "";
  
            // ✅ Fetch city name using state code
            const stateCities = matchedState
              ? City.getCitiesOfState(country_code.toUpperCase(), stateIsoCode)
              : [];
  
            const matchedCity = stateCities.find(
              (c) => c.name.toLowerCase().includes(city.toLowerCase())
            );
  
            const fullCityName = matchedCity ? matchedCity.name : "";
  
            // ✅ Debug logs to verify extracted values
            console.log("✅ Extracted Location Data:", {
              country: fullCountryName,
              state: fullStateName,
              city: fullCityName,
              pincode: postcode,
            });
  
            // ✅ Ensure values are set correctly in the form
            const newAddress = {
              country: fullCountryName || "",
              state: fullStateName || "",
              city: fullCityName || "",
              pincode: postcode || "",
            };
  
            setAddress(newAddress);
            handleLocationChange(newAddress);
  
            // ✅ Ensure `setValue` updates correctly
            setTimeout(() => {
              setValue("country", newAddress.country);
              setValue("state", newAddress.state);
              setValue("city", newAddress.city);
              setValue("pincode", newAddress.pincode);
            }, 100);
          } else {
            alert("Unable to fetch address from location.");
          }
        } catch (error) {
          console.error("❌ Error fetching location:", error);
          alert("Failed to fetch location details. Please try again.");
        }
      },
      (error) => {
        console.error("❌ Error getting geolocation:", error);
        alert("Unable to retrieve your location.");
      }
    );
  };

  const [hasTriedConfirm, setHasTriedConfirm] = useState(false);

  const handleSelectAddress = (id) => {
    console.log("✅ handleSelectAddress called with ID:", id);
    if(id != null) {
      setSelectedAddress(id);
      setHasTriedConfirm(false); 
    }else {
      console.log("✅ handleSelectAddress called with ID:", id);
      alert("Please select an address.");
    }
  };

  // useEffect(() => {
  //   console.log("🔄 useEffect Triggered - Updated selectedAddress:", selectedAddress);
  // }, [selectedAddress]);

  const handleConfirm = () => {
    // console.log("🟡 handleConfirm clicked!");
    console.log("🔍 selectedAddress BEFORE check:", selectedAddress);

    setHasTriedConfirm(true); 

    if (!selectedAddress) {
      console.log("❌ No address selected, showing alert.");
      alert("Please select an address.");
      return;
    }

    console.log("✅ selectedAddress AFTER check (Valid):", selectedAddress);
    onSelect(selectedAddress);
    onClose();
  };


  useEffect(() => {
    if (hasTriedConfirm && selectedAddress) {
      console.log("🚀 Address selected after confirm click, proceeding...");
      onSelect(selectedAddress);
      onClose();
    }
  }, [selectedAddress, hasTriedConfirm, onSelect, onClose]);
  
  // const handleAddNewAddress = async () => {
  //   if (
  //     !newAddress.name ||
  //     !newAddress.phone ||
  //     !newAddress.address_line_1 ||
  //     !newAddress.city ||
  //     !newAddress.state ||
  //     !newAddress.country ||
  //     !newAddress.postal_code
  //   ) {
  //     setErrors({
  //       name: !newAddress.name ? "This field is required." : "",
  //       phone: !newAddress.phone ? "This field is required." : "",
  //       address_line_1: !newAddress.address_line_1 ? "This field is required." : "",
  //       city: !newAddress.city ? "This field is required." : "",
  //       state: !newAddress.state ? "This field is required." : "",
  //       country: !newAddress.country ? "This field is required." : "",
  //       postal_code: !newAddress.postal_code ? "This field is required." : "",
  //     });
  //     return;
  //   }

  //   try {
  //     let accessToken = localStorage.getItem("accessToken");
  //     const response = await fetch("https://vastuauraaligners.com/account/addresses/", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${accessToken}`,
  //       },
  //       body: JSON.stringify(newAddress),
  //     });

  //     if (response.ok) {
  //       const addedAddress = await response.json();
  //       addresses.push(addedAddress); // Add new address to the list
  //       setSelectedAddress(addedAddress.id);
  //       setIsAddingNew(false);
  //     } else {
  //       alert("Failed to add address.");
  //     }
  //   } catch (error) {
  //     console.error("Error adding address:", error);
  //     alert("Something went wrong. Please try again.");
  //   }
  // };

  const handleRegister = async (formData) => {
    if (
      !formData.userName ||
      !formData.mobile ||
      !formData.address ||
      !formData.city ||
      !formData.state ||
      !formData.country ||
      !formData.pincode ||
      !formData.address_type
    ) {
      setErrors({
        userName: !formData.userName ? "This field is required." : "",
        mobile: !formData.mobile ? "This field is required." : "",
        address: !formData.address ? "This field is required." : "",
        city: !formData.city ? "This field is required." : "",
        state: !formData.state ? "This field is required." : "",
        country: !formData.country ? "This field is required." : "",
        pincode: !formData.pincode ? "This field is required." : "",
        address_type: !formData.address_type ? "This field is required." : "",
      });
      return;
    }
  
    try {
      const newAddress = {
        customer_name: formData.userName, 
        phone_number: formData.mobile,
        address_line_1: formData.address,
        city: formData.city,
        state: formData.state,
        country: formData.country,
        postal_code: formData.pincode,
        address_type: formData.address_type,
      };
  
      let accessToken = localStorage.getItem("accessToken");
      const response = await fetchWithAuth(`${API_BASE_URL}/account/addresses/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(newAddress),
      });
  
      if (response.ok) {
        const addedAddress = await response.json();
        addresses.push(addedAddress); 
        setSelectedAddress(addedAddress.id);
        setIsAddingNew(false);

      } else {
        alert(" Failed to add address.");
      }
    } catch (error) {
      console.error(" Error in registration process:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      resetRegisterForm();
    }
  };
  

  return (
        <div className="modal-overlay">
          <div className="modal-content shadow-lg">
            <div className="close-button">
              {isAddingNew?(<button
                className="btn btn-custom-back-button d-flex align-items-center justify-content-center pe-2"
                onClick={() => {
                  setIsAddingNew(false);
                }}
              >
                <span className="material-icons me-2" >
                  arrow_back
                </span> Back
              </button>
              ):(
                <button className="modal-close-button" onClick={onClose}>
                  &times;
                </button>
              )}
            </div>

            {!isAddingNew ? (<h2>Select a Delivery Address</h2>):null}

            {!isAddingNew ? (
              <div>
                <div className="row">
                  <div className="">
                    <div className="address-list">
                      {addresses.map((addr) => (
                        <label
                          key={addr.id}
                          className={`address-item ${selectedAddress === addr.id ? "selected" : ""}`}
                        >
                          <div className="col-md-2">
                            <input
                              type="radio"
                              name="selectedAddress"
                              value={addr.id}
                              onChange={() => handleSelectAddress(addr.id)}
                            />
                          </div>
                          <div className="col-md-10">
                            <span>
                              {addr.customer_name} - {addr.phone_number} <br />
                              {addr.address_line_1}, {addr.city}, {addr.state}, {addr.country}, {addr.postal_code}
                            </span>
                          </div>
                        </label>
                      ))}
                    </div>

                    <button className="add-address-button" onClick={() => setIsAddingNew(true)}>
                      + Add New Address
                    </button>

                    {/* <div className="modal-buttons"> */}
                      <div className="d-flex justify-content-end gap-3 mt-4">
                        <button
                          type="button"
                          className="btn btn-warning w-50"
                          onClick={onClose}
                        >
                          Cancel
                        </button>
                        {/* Show error message if confirm was clicked but no selection made */}
                        {hasTriedConfirm && !selectedAddress && (
                          <p style={{ color: "red" }}>❗ Please select an address before confirming.</p>
                        )}

                        <button
                          type="submit"
                          className="btn btn-primary w-50"
                          onClick={handleConfirm}
                          disabled={!selectedAddress}
                        >
                          Confirm
                        </button>
                        {/* <button type="submit" className="btn btn-primary w-50" onClick={handleConfirm}>
                        Confirm
                        </button> */}
                      </div>
                    {/* </div> */}
                  </div>
                </div>
              </div>
            ) : (
              <div className="new-address-form d-flex justify-content-center align-items-center">
                <div className="container">
                  <div className="rounded bg-white p-4">
                    <div className="row justify-content-center">
                      <div className="col-md-10">
                        <h5 className="mb-4">Enter your details</h5>
                        <div className="form-container text-start">
                          <form onSubmit={handleRegisterSubmit(handleRegister)}>
                            <div className="mb-3">
                              <label htmlFor="name" className="form-label">
                                Name<span className="required">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control text-start"
                                id="name"
                                placeholder="Name"
                                {...registerRegister("userName", { required: "Name is required" })}
                              />
                              {errors.userName && <p className="text-danger">{errors.userName.message}</p>}
                            </div>

                            <div className="mb-3">
                              <label htmlFor="mobile" className="form-label">
                                Mobile number<span className="required">*</span>
                              </label>
                              <input
                                type="tel"
                                className="form-control text-start"
                                id="mobile"
                                placeholder="Mobile number"
                                {...registerRegister("mobile", {
                                  pattern: {
                                    value: /^[0-9]{10}$/,
                                    message: "Enter a valid 10-digit mobile number",
                                  },
                                })}
                              />
                              {errors.mobile && <p className="text-danger">{errors.mobile.message}</p>}
                            </div>

                            <div className="mb-3">
                              <div className="d-flex justify-content-between align-items-center">
                                <label htmlFor="address" className="form-label mb-0">
                                  Address (Area and Street) <span className="required">*</span>
                                </label>
                                
                                <button
                                  type="button"
                                  className="btn btn-primary btn-sm px-2 small-btn mb-0"
                                  onClick={getCurrentLocation}
                                >
                                  <span className="material-icons me-1" style={{ color: "#FFF", fontSize: "12px" }}>
                                    my_location
                                  </span>
                                  Current Location
                                </button>
                              </div>

                              <textarea
                                className="form-control text-start mt-2"
                                id="address"
                                rows="2"
                                placeholder="Address (Area and Street)"
                                {...registerRegister("address", { required: "Address is required" })}
                              ></textarea>

                              {errors.address && <p className="text-danger">{errors.address.message}</p>}
                            </div>

                            {/* Country-State-City Selector */}
                            <CountryStateCitySelector
                              onChange={handleLocationChange}
                              countryValue={address.country}
                              stateValue={address.state}
                              cityValue={address.city}
                            />

                            <div className="mb-3">
                              <label htmlFor="pincode" className="form-label">
                                Pincode  <span className="required">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control text-start"
                                id="pincode"
                                placeholder="Pincode"
                                {...registerRegister("pincode", {
                                  required: "Pincode is required",
                                  pattern: {
                                    value: /^[1-9][0-9]{5}$/,
                                    message: "Enter a valid 6-digit pincode",
                                  },
                                })}
                              />
                              {errors.pincode && <p className="text-danger">{errors.pincode.message}</p>}
                            </div>

                            {/* <div className="mb-3">
                              <label htmlFor="alternate-phone" className="form-label">
                                Alternate Mobile Number
                              </label>
                              <input
                                type="tel"
                                className="form-control"
                                id="alternate-phone"
                                placeholder="Alternate Mobile Number"
                                {...registerRegister("alternateMobile", {
                                  pattern: {
                                    value: /^[0-9]{10}$/,
                                  },
                                  message: "Enter a valid 10-digit mobile number",
                                })}
                              />
                            </div> */}

                            <div className="mb-3 d-flex align-items-center address-type-container">
                              <label className="form-label address-type-label mb-0">
                                Address Type: <span className="required">*</span>
                              </label>

                              <div className="d-flex align-items-center gap-3">
                                <div className="form-check form-check-inline d-flex align-items-center">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="address_type"
                                    id="home"
                                    value="home"
                                    {...registerRegister("address_type", { required: "Select an address type" })}
                                  />
                                  <label className="form-check-label ms-2" htmlFor="home">
                                    Home
                                  </label>
                                </div>

                                <div className="form-check form-check-inline d-flex align-items-center">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="address_type"
                                    id="work"
                                    value="work"
                                    {...registerRegister("address_type", { required: "Select an address type" })}
                                  />
                                  <label className="form-check-label ms-2" htmlFor="work">
                                    Work
                                  </label>
                                </div>
                              </div>

                              {errors.address_type && (
                                <p className="text-danger">{errors.address_type.message}</p>
                              )}
                            </div>


                            <div className="d-flex justify-content-end gap-3">
                              <button
                                type="button"
                                className="btn btn-warning w-50"
                                onClick={() => {
                                  setIsAddingNew(false);
                                }}
                              >
                                Cancel
                              </button>
                              <button type="submit" className="btn btn-primary w-50">
                                Save
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
    );
};

export default AddressSelectionModal;
